<template>
  <el-dialog
    v-el-drag-dialog
    :visible="visible"
    :title="$t('SeaExport.FCLFreightTariff')"
    width="1150px"
    :close-on-click-model="false"
    class="fcl-price-dialog"
    @close="handleClose"
  >
    <div class="query-container">
      <div class="header">
        <div class="simple">
          <div class="query-toggle" @click="isSimpleQuery=!isSimpleQuery">
            <!--<i
              :class="isSimpleQuery? ['el-icon-d-arrow-right','el-icon&#45;&#45;right'] : ['el-icon-d-arrow-left','el-icon&#45;&#45;left']"
              @click="isSimpleQuery=!isSimpleQuery"
            />-->
            <img v-if="isSimpleQuery" width="100%" src="/static/arrow-down.png">
            <img v-else width="100%" src="/static/arrow-up.png">
          </div>
          <el-input
            v-show="isSimpleQuery"
            v-model="priceNo"
            :placeholder="$t('SeaExport.PleaseInputTariffSheet')"
            style="width:160px"
          />
          <div class="query-buttons">
            <el-button
              type="primary"
              @click="onSearch"
            >{{ $t('SeaExport.Query') }}</el-button>
            <el-button
              type="primary"
              @click="handleResetSearchParams"
            >{{ $t('SeaExport.ResetFilter') }}</el-button>
            <el-button
              type="primary"
              @click="onSelect"
            >{{ $t('SeaExport.Select') }}</el-button>
            <el-button @click="handleClose">{{ $t('SeaExport.Cancel') }}</el-button>
          </div>
        </div>

        <div :class="[isSimpleQuery?'check-options-flex': 'check-options-absolute']">
          <el-checkbox class="data-red" style="margin-right: 5px">{{ $t('SeaExport.GetCostsByTheCabinet') }}</el-checkbox>
          <el-checkbox class="data-red" checked>{{ $t('SeaExport.ShippingFeesAreALLINTHEWAYImport') }}</el-checkbox>
        </div>
        <div>
          <span style="float:right;color:blue;margin-left:5px">
            <b>{{ lblTier }}</b>
          </span>
        </div>
      </div>
      <el-form
        v-show="!isSimpleQuery"
        ref="advSearch"
        inline
        label-width="85px"
        label-position="left"
        style="padding-bottom:5px;"
        :model="form"
      >
        <el-col>
          <el-form-item
            :label="$t('SeaExport.PortOfLoading')"
            prop="pol"
          >
            <cargo-advance-select
              ref="loadingPortCode"
              :select-type="selectTypeNames.basic_data_Seaport"
              filterable
              :default-value="form.pol"
              tag-name="englishName"
              @parentCallBack="p=>form.pol=p.value"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.ShippingCompany')"
            prop="carrier"
          >
            <cargo-advance-select
              filterable
              :select-type="selectTypeNames.basic_data_Company"
              :method-params="{seaCmp:true}"
              :default-value="form.carrier"
              style="width:100%;"
              @parentCallBack="p=>form.carrier=p.value"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.ValidFrom')"
            prop="beginDate"
          >
            <el-date-picker
              v-model="form.beginDate"
              type="date"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item
            :label="$t('SeaExport.PortOfDestination')"
            prop="pod"
          >
            <cargo-advance-select
              ref="pod"
              :select-type="selectTypeNames.basic_data_Seaport"
              filterable
              :default-value="form.pod"
              tag-name="englishName"
              @parentCallBack="p=>form.pod=p.pod"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.BookingAgent')"
            prop="bookingAgent"
          >
            <cargo-advance-select
              filterable
              :select-type="selectTypeNames.basic_data_Company"
              :method-params="{overseaAgent:true}"
              :default-value="form.bookingAgent"
              @parentCallBack="p=>form.bookingAgent=p.value"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.ValidTo')"
            prop="endDate"
          >
            <el-date-picker
              v-model="form.endDate"
              type="date"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item
            class="weekday"
            prop="frequencys"
          >
            <el-checkbox-group v-model="form.frequencys">
              <el-checkbox
                :label="week[0]"
              />
              <el-checkbox
                :label="week[1]"
              />
              <el-checkbox
                :label="week[2]"
              />
              <el-checkbox
                :label="week[3]"
              />
              <el-checkbox
                :label="week[4]"
              />
              <el-checkbox
                :label="week[5]"
              />
              <el-checkbox
                :label="week[6]"
              />
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-form>
    </div>
    <cargo-ag-grid
      :show-side-bar="false"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      style="width:100%;height:300px"
      @gridReady="params=>gridApi=params.api"
    />
  </el-dialog>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import { queryEffectivePriceFcl, queryByPriceNo } from '@/api/price/priceFcl'
import { Company } from '@/class/model/mdm/Company'
import { cacheName, cache } from '@/utils/cacheManager'
import ColumnUtils from '@/utils/ColumnUtils'
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'

export const FREQUENCYS = ['1', '2', '3', '4', '5', '6', '7']
export default {
  name: 'FclPriceDialog',
  components: { cargoAdvanceSelect },
  props: {
    job: { type: Object, required: true },
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      loading: null,
      selectTypeNames: TYPE_NAMES,
      isSimpleQuery: false,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onSelect
      },
      columnDefs: [
        {
          headerName: this.$t('SeaExport.PriceNo'),
          field: 'priceNo',
          suppressMenu: true,
          width: 150,
          tooltip: (params) => {
            return this.priceNoTipFunc(params.data.branchId)
          }
        },
        {
          headerName: this.$t('SeaExport.BranchCMP'),
          field: 'branchId',
          suppressMenu: true,
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', params.value, 'code')
          }
        },
        {
          headerName: this.$t('SeaExport.PortOfLoading'),
          field: 'pol',
          suppressMenu: true,
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('SeaExport.PortOfDestination'),
          field: 'pod',
          suppressMenu: true,
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('SeaExport.IsDirect'),
          field: 'direct',
          suppressMenu: true,
          width: 100,
          cellRenderer: (params) => {
            return this.boolLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.TransitPort'),
          field: 'via',
          suppressMenu: true,
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('SeaExport.PriceState'),
          suppressMenu: true,
          width: 100,
          cellRenderer: (params) => {
            return this.priceStateLabelFunc(params.data)
          }
        },
        {
          headerName: this.$t('SeaExport.Trend'),
          field: 'trend',
          suppressMenu: true,
          width: 100,
          cellRenderer: (params) => {
            return this.trendLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Share'),
          field: 'share',
          suppressMenu: true,
          width: 100,
          cellRenderer: (params) => {
            return this.shareColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Currency'),
          field: 'currency',
          suppressMenu: true,
          width: 100
        },
        {
          headerName: this.$t('SeaExport.ContainerType'),
          field: 'eqType',
          suppressMenu: true,
          width: 100
        },
        {
          headerName: '20＇',
          field: 'uuid',
          suppressMenu: true,
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: false,
            tag: 'span',
            attrs: {
              textConverter: (val) => {
                return this.priceColumnLabelFunc20(val)
              },
              classFunc: (params) => { return this.ColorfulNumListItemRenderer(params.data, 'cost20') }
            }
          }},
        {
          headerName: '40＇',
          field: 'uuid',
          suppressMenu: true,
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: false,
            tag: 'span',
            attrs: {
              textConverter: (val) => {
                return this.priceColumnLabelFunc40(val)
              },
              classFunc: (params) => { return this.ColorfulNumListItemRenderer(params.data, 'cost40') }
            }
          }
        },
        {
          headerName: '40＇HC',
          field: 'uuid',
          suppressMenu: true,
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: false,
            tag: 'span',
            attrs: {
              textConverter: (val) => {
                return this.priceColumnLabelFunc40HC(val)
              },
              classFunc: (params) => { return this.ColorfulNumListItemRenderer(params.data, 'costhc') }
            }
          }
        },
        {
          headerName: '45＇',
          field: 'uuid',
          suppressMenu: true,
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: false,
            tag: 'span',
            attrs: {
              textConverter: (val) => {
                return this.priceColumnLabelFunc45(val)
              },
              classFunc: (params) => { return this.ColorfulNumListItemRenderer(params.data, 'cost45') }
            }
          }
        },
        {
          headerName: this.$t('SeaExport.TaxRate') + '(Cost)',
          field: 'costVat',
          suppressMenu: true,
          width: 100
        },
        {
          headerName: this.$t('SeaExport.TaxRate') + '(Sell)',
          field: 'sellVat',
          suppressMenu: true,
          width: 100
        },
        {
          headerName: this.$t('SeaExport.ChargeClause'),
          field: 'term',
          suppressMenu: true,
          width: 100,
          cellRenderer: (params) => {
            return this.dataGridColumnPaymentFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.ShippingCompany'),
          field: 'carrier',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'shortName')
          },
          tooltip: (params) => {
            return this.dataGridColumnCarrierTipFunc(params.data.carrier)
          }
        },
        {
          headerName: this.$t('SeaExport.ContractNo'),
          field: 'contractNo',
          suppressMenu: true,
          width: 100
        },
        {
          headerName: 'Output Code',
          field: 'shippingLine',
          suppressMenu: true,
          width: 100
        },
        {
          headerName: this.$t('SeaExport.AirlineCode'),
          field: 'lane',
          suppressMenu: true,
          width: 100
        },
        {
          headerName: this.$t('SeaExport.PriceFrom'),
          field: 'bookingAgent',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'shortName')
          },
          tooltip: (params) => {
            return this.bookingAgentTipFunc(params.data.bookingAgent)
          }
        },
        {
          headerName: this.$t('SeaExport.SailingDate'),
          suppressMenu: true,
          width: 100,
          cellRenderer: (params) => {
            return this.isFrequency(params.data)
          }
        },
        {
          headerName: this.$t('SeaExport.Voyage2'),
          field: 'days',
          suppressMenu: true,
          width: 100,
          cellRenderer: (params) => {
            return this.daysColumnLabelFunc(params.value)
          }
        },
        {
          headerName: 'ServiceMode',
          field: 'serviceMode',
          suppressMenu: true,
          width: 100
        },
        {
          headerName: 'ServiceCode',
          field: 'serviceCode',
          suppressMenu: true,
          width: 100
        },
        {
          headerName: this.$t('SeaExport.Cargo'),
          field: 'commodity',
          suppressMenu: true,
          width: 100
        },
        {
          headerName: this.$t('SeaExport.Dock'),
          field: 'dock',
          suppressMenu: true,
          width: 100
        },
        {
          headerName: this.$t('SeaExport.ValidFrom'),
          field: 'beginDate',
          suppressMenu: true,
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.ValidTo'),
          field: 'endDate',
          suppressMenu: true,
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Remarks'),
          field: 'remark',
          suppressMenu: true,
          width: 100
        }
      ],
      rowData: [],
      gridApi: null,
      priceNo: '',
      lblTier: '',
      targetLevel: 1,
      containerInfo: '',
      week: [],
      form: {
        pol: null,
        pod: null,
        beginDate: null,
        endDate: null,
        bookingAgent: null,
        carrier: null,
        frequencys: []
      }
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.initSearch()
      }
    }
  },
  methods: {
    // 初始查询条件
    async initSearch() {
      await cache.load(cacheName.CONFIG)
      this.form.pol = this.job.loadingPortCode
      this.form.pod = this.job.dischargingPortCode
      this.form.carrier = this.job.carrierId
      const bookingAgent = await Company.getCompanyById(this.job.bookingAgent)
      if (bookingAgent) {
        if (bookingAgent.linkedBranchId > 0 || String(cache.config.get('PFTableBookingAgent')) !== '1') {
          this.form.bookingAgent = ''
        } else {
          this.form.bookingAgent = Number(this.job.bookingAgent)
        }
      }
      this.form.beginDate = this.job.etd
      this.form.endDate = this.job.etd

      let day = new Date(Date.parse(this.job.etd)).getDay() //  ('星期日','星期一','星期二','星期三','星期四','星期五','星期六') 0,1,........
      if (day === 0) {
        day = 7
      }
      this.week = [this.$t('SeaExport.MON'), this.$t('SeaExport.TUE'), this.$t('SeaExport.WED'), this.$t('SeaExport.THU'), this.$t('SeaExport.FRI'), this.$t('SeaExport.SAT'), this.$t('SeaExport.SUN')]

      this.form.frequencys.push(this.week[day - 1])

      this.containerInfo = ''
      const seaEQs = this.job.seaEQ
      for (const seaEQ of seaEQs) {
        this.containerInfo += seaEQ.eqSize + '\'' + seaEQ.eqType + '×' + seaEQ.eqQuantity + ' '
      }
      this.lblTier = this.containerInfo + this.$t('SeaExport.CostLeave') + (this.targetLevel === 0 ? 'Cost' : 'T' + (this.targetLevel === 99 ? 3 : this.targetLevel))

      if (this.job.priceNo) {
        this.priceNo = this.job.priceNo
        this.isSimpleQuery = true
      } else {
        this.isSimpleQuery = false
      }
    },
    // 查询
    onSearch() {
      const proxy = this.getSearchProxy()
      if (!proxy.hasOwnProperty('priceNo')) {
        this.loading = getLoading()
        queryEffectivePriceFcl(proxy).then(res => {
          this.rowData = res.data
        }).finally(() => {
          this.loading.close()
        })
      } else {
        this.loading = getLoading()
        proxy.tenantId = 0 // 符合后端api 入参
        queryByPriceNo(proxy).then(res => {
          this.rowData = res.data
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    getSearchProxy() {
      let proxy = {}
      proxy.limited = true
      if (this.isSimpleQuery) {
        if (this.priceNo) {
          proxy.priceNo = this.priceNo
          return proxy
        } else {
          return null
        }
      } else {
        proxy = { ...this.form }
        // 有效期
        if (proxy.endDate) {
          proxy.endDate = proxy.endDate.substr(0, 10) + ' 23:59:59'
        }
        proxy.frequencys = []
        let index = 0
        for (const day of this.form.frequencys) {
          index = this.week.indexOf(day)
          if (index >= 0) {
            index += 1
            proxy.frequencys.push('FREQUENCY' + String(index))
          }
        }
      }
      return proxy
    },
    // 重置条件
    handleResetSearchParams() {
      this.priceNo = ''
      this.$refs['advSearch'].resetFields()
    },
    // 选择
    onSelect(params) {
      let rows = []
      if (params.type == 'rowDoubleClicked') {
        rows = [params.data]
      } else {
        const rowIndex = this.gridApi.getFocusedCell().rowIndex
        rows = [this.gridApi.getRowNode(rowIndex).data]
      }

      if (rows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectThePrice'))
        return
      }
      const pf = rows[0]
      const priceState = Number(pf.priceState)
      if (priceState === 1) { // Suspend
        this.$message.warning(this.$t('Message.PleaseBeNotedThatThisRateIsUnderSuspendSailing'))
      } else if (priceState === 2) { // Reject
        if (pf.reject20 && pf.reject40 && pf.rejectHC && pf.reject45) {
          this.$message.warning(this.$t('Message.PleaseBeNotedThatThisRateIsUnavailableNow'))
        } else {
          this.$message.warning(this.$t('Message.PleaseBeNotedThatThisRateIsOnlyForPartOfEQType'))
        }
      } else if (priceState === 5) {
        this.$message.warning(this.$t('Message.PleaseBeNotedThatThisRateIsUnderOverbookedStatus'))
      }
      if (this.$store.getters.currentOfficeId === pf.branchId) {
        if (this.job.bookingAgent !== this.form.bookingAgent) {
          this.$message.warning(this.$t('Message.TheOriginOfSelectedRateIsDifferentFromBookingAgent'))
        }
      }

      // todo
      /* if(pf.isDirty){
        pf.reload2(function(event:ResultEvent):void{
          pf=event.result as PriceFcl;
          visible=false;
          dispatchEvent(new Event("itemSelected"));
        },function(event:FaultEvent):void{
          this.$message.error(this.$t('Message.RefreshRateFailed'))
        });
      } else {
        this.visible=false;
        this.dispatchEvent(new Event("itemSelected"));
      }*/
      this.$emit('close')
      this.$emit('itemSelected', rows[0])
    },
    handleClose() {
      this.$emit('close')
    },
    boolLabelFunc(value) {
      if (value) {
        return value ? 'Y' : 'N'
      }
      return ''
    },
    isFrequency(data) {
      if (data) {
        const arr = []
        for (const field of FREQUENCYS) {
          if (data['frequency' + field]) {
            arr.push(field)
          }
        }
        return arr.join('/')
      }
      return null
    },
    priceStateLabelFunc(data) {
      if (!data || !data.hasOwnProperty('priceState')) return null
      const priceState = data.priceState
      switch (priceState) {
        case 0:
          if (data.endDate.time < new Date().time) {
            return this.$t('Message.Invalidation')
          }
          return this.$t('Message.Normal')
        case 1:
          return this.$t('Message.suspension')
        case 2:
          return this.$t('Message.NoPickingUp')
        case 3:
          return this.$t('Message.Inquiry')
        case 4:
          return this.$t('Message.Tension')
        case 5:
          return this.$t('Message.OverStowage')
      }
      return this.$t('Message.Normal')
    },
    trendLabelFunc(trend) {
      if (!trend) return ''
      if (String(trend) === '1') return '↑'
      if (String(trend) === '-1') return '↓'
      return ''
    },
    shareColumnLabelFunc(share) {
      if (!share) return ''
      if (share === 'SELF') return this.$t('Pricing.Self')
      if (share === 'SHARE') return this.$t('Pricing.Share')
      return ''
    },
    // textConverter 入参是 field value ,通过uuid转一层
    priceColumnLabelFunc20(uuid) {
      const data = this.rowData.find(p => p.uuid === uuid)
      const dataField = 'cost20'
      return this.priceColumnLabelFuncUtil(data, dataField)
    },
    priceColumnLabelFunc40(uuid) {
      const data = this.rowData.find(p => p.uuid === uuid)
      const dataField = 'cost40'
      return this.priceColumnLabelFuncUtil(data, dataField)
    },
    priceColumnLabelFunc40HC(uuid) {
      const data = this.rowData.find(p => p.uuid === uuid)
      const dataField = 'costhc'
      return this.priceColumnLabelFuncUtil(data, dataField)
    },
    priceColumnLabelFunc45(uuid) {
      const data = this.rowData.find(p => p.uuid === uuid)
      const dataField = 'cost45'
      return this.priceColumnLabelFuncUtil(data, dataField)
    },
    priceColumnLabelFuncUtil(data, dataField) {
      if (!data || data[dataField] === null) return ''
      const priceFieldMap = { '0': 'cost', '1': 'one', '2': 'two', '99': 'three' }
      const newField = this.targetLevel === 0 ? dataField : dataField.replace('cost', priceFieldMap[this.targetLevel])
      const num = data[newField]

      if (num === 0.0) return '0'
      if (!isNaN(num)) {
        if (num === PriceConstant.NIL) return ''
        if (num < 0) return '(' + String((-num).toFixed(2)) + ')'
        return num.toFixed(2)
      }
      return ''
    },
    ColorfulNumListItemRenderer(data, dataField) {
      if (!data) return ''
      const trend = Number(data.trend)
      const className = []
      switch (trend) {
        case -1:
          className.push('data-green')
          break
        case 0:
          break
        case 1:
          className.push('data-red')
          break
      }
      let isLineThrough = false
      if (data.hasOwnProperty('priceState') && data['priceState'] === 2) {
        let rejectField = dataField.replace('cost', 'reject')
        rejectField = rejectField === 'rejecthc' ? 'rejectHC' : rejectField
        isLineThrough = data.hasOwnProperty(rejectField) && data[rejectField]
      }
      if (isLineThrough) {
        className.push('data-through')
      }
      return className
    },
    dataGridColumnPaymentFunc(payment) {
      if (!payment) { return '' }
      if (!payment)payment = 'P'
      switch (payment) {
        case 'P':
          return this.$t('Message.Prepaid')
        case 'C':
          return this.$t('Message.Collect')
        case 'B':
          return this.$t('Message.PrePayTheSamePrice')
      }

      return ''
    },
    daysColumnLabelFunc(days) {
      if (!days) { return '' }
      const num = days
      if (num === 0.0 || num === '0') return '-'
      return days
    },
    priceNoTipFunc(branchId) {
      if (this.$store.getters.language === 'zh') {
        return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', branchId, 'chineseName')
      } else {
        return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', branchId, 'englishName')
      }
    },
    dataGridColumnCarrierTipFunc(carrier) {
      if (this.$store.getters.language === 'zh') {
        return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(carrier), 'chineseName')
      } else {
        return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(carrier), 'englishName')
      }
    },
    bookingAgentTipFunc(bookingAgent) {
      if (this.$store.getters.language === 'zh') {
        return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(bookingAgent), 'chineseName')
      } else {
        return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(bookingAgent), 'englishName')
      }
    }
  }
}
</script>

<style lang='scss'>
  .data-red {
    color: #FF0000;
    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #FF0000;
    }
  }
  .data-green{
    color: #228B22;
  }
  .data-through{
    text-decoration:line-through;
  }

  .fcl-price-dialog {
    .query-container {
      position: relative;
      display: flex;
      flex-direction: column;
      margin-bottom: 10px;
      .header {
        display: flex;
        .simple {
          display: flex;
          flex: 1;
          margin-bottom: 10px;
          .query-toggle {
            img{
              display: inline-block;
              vertical-align: middle;
            }
            /*i {
              font-size: 20px;
              font-weight: bold;
              transform: rotate(90deg);
              margin: 0;
              vertical-align: middle;
            }*/
          }
          .el-input {
            margin-left: 5px;
          }
          .query-buttons {
            margin-left: 5px;
            .el-button {
              margin: 0 4px;
            }
          }
        }
        .check-options {
          &-flex {
            position: relative;
          }
          &-absolute {
            position: absolute;
            right: 0;
            bottom: 0;
          }
        }
      }
      .el-form-item {
        margin-bottom: 0 !important;
      }
      .weekday {
        .el-form-item {
          &__content {
            display: inline;
          }
        }
      }
    }
  }
</style>
